module.exports = "<uch></uch>\r\n<head-title params='title:\"应用列表 / 授权列表 / 访问记录\"'></head-title>\r\n<record></record>";


//////////////////
// WEBPACK FOOTER
// ./src/component/appConfig/template/recordIndex.html
// module id = 195
// module chunks = 0